/** Widget-grid geometry (M0 §0.7). Pure: no DOM, no React. */
export const ROW_PX = 70
export const GAP_PX = 14
export const MAX_COLUMNS = 4
export const MIN_COLUMN_PX = 260

export type Cols = 1 | 2 | 3 | 4
export type SizeStep = 1 | 2 | 3 | 4 | 5 | 6
export type WidgetLayoutItem<Id extends string> = { id: Id; w: Cols; h: SizeStep }

/**
 * How many columns of at least `minColumnPx` fit in `containerPx`, 1 to 4. A
 * non-finite or non-positive width is the clamp floor (jsdom reports 0), not an
 * unclassified input.
 */
export function fittedColumns(containerPx: number, minColumnPx: number = MIN_COLUMN_PX): Cols {
  if (!Number.isFinite(containerPx) || containerPx <= 0) return 1
  const n = Math.floor((containerPx + GAP_PX) / (minColumnPx + GAP_PX))
  return Math.min(MAX_COLUMNS, Math.max(1, n)) as Cols
}

/** A widget never spans more columns than exist. */
export const colSpan = (w: Cols, n: Cols): Cols => Math.min(w, n) as Cols
export const rowSpan = (h: SizeStep): number => h + 1
export const heightPx = (h: SizeStep): number => ROW_PX * (h + 1) + GAP_PX * h
